import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SearchIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M8.32562 13.6512C11.2669 13.6512 13.6512 11.2669 13.6512 8.32562C13.6512 5.38436 11.2669 3 8.32562 3C5.38436 3 3 5.38436 3 8.32562C3 11.2669 5.38436 13.6512 8.32562 13.6512Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.8506 11.7895C12.5577 11.4966 12.0829 11.4966 11.79 11.7895C11.4971 12.0824 11.4971 12.5573 11.79 12.8502L12.2323 13.2925C12.2328 13.293 12.2333 13.2935 12.2338 13.294L12.2347 13.2949L16.6718 17.732C16.9647 18.0249 17.4396 18.0249 17.7325 17.732C18.0254 17.4391 18.0254 16.9642 17.7325 16.6713L13.2969 12.2357C13.2964 12.2352 13.2959 12.2347 13.2954 12.2342L12.8506 11.7895Z"
                fill="currentColor"
                stroke="none"
            />
        </SvgIcon>
    );
};
